import React from 'react';
import { CommonPageStep } from '..';
import { Button, Grid } from '@mui/material';
import { bool } from 'prop-types';
import { setAppPageStep } from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export interface EntryPageElementInterface {
  welcomeImageSection: JSX.Element;
  loginButton: JSX.Element;
  signupButton: JSX.Element;
}

export const EntryPageElement = (): EntryPageElementInterface => {
  // Local Variables
  let _welcomeMsgIndex = 0;

  // Hooks
  const [welcomeMsgIndex, setWelcomeMsgIndex] = React.useState(1); // Positive integer

  const loginButtonClickHandler = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    console.debug('Redirecting to /Login');
    // To-do: Add transition animation
    // window.location.href = '/Login';
    outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
  };

  const signupButtonClickHandler = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    console.debug('Redirecting to /Signup');
    // To-do: Add transition animation
    // window.location.href = '/Signup';
    outsideComponentDispatch(setAppPageStep(CommonPageStep.SIGNUP));
  };

  const partnershipSignupButtonClickHandler = (
    event: React.MouseEvent<HTMLButtonElement>,
  ): void => {
    console.debug('Redirecting to /SignupPartnerShip');
    window.location.href = '/CreatePartnershipProfile';
  };

  React.useEffect(() => {
    // Image Roller
    setInterval(() => {
      _welcomeMsgIndex += 1;
      _welcomeMsgIndex %= 4;
      if (_welcomeMsgIndex === 0) {
        _welcomeMsgIndex++;
      }

      setWelcomeMsgIndex(_welcomeMsgIndex);
    }, 3000);
  }, []);

  return {
    welcomeImageSection: (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <img src={`assets/entry/welcome-msg-${welcomeMsgIndex}@3x.png`} />
          </Grid>
          <Grid item xs={12}>
            <img
              src={`assets/entry/dot-slider-${welcomeMsgIndex}-of-3@3x.png`}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    ),
    loginButton: (
      <Button
        id="entry-page-login-button"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        variant="text"
        onClick={loginButtonClickHandler}
      >
        Log in
      </Button>
    ),
    signupButton: (
      <Button
        id="entry-page-signup-button"
        sx={{ width: 'inherite' }}
        fullWidth={true}
        variant="contained"
        onClick={signupButtonClickHandler}
      >
        Sign Up
      </Button>
    ),
  };
};
